import { createTypes } from 'reduxsauce';

export default createTypes(
    `
    SET_NOTIFICATIONS
`,
    {
        prefix: 'notification/'
    }
);
